(function() {
  'use strict';

  // Configurar data de término da promoção
  // ALTERE PARA A DATA CORRETA
  const promoEndDate = new Date('2026-03-31T23:59:59').getTime();

  function updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = promoEndDate - now;

    if (timeLeft < 0) {
      // Promoção expirou
      const countdownElements = document.querySelectorAll('.countdown-timer');
      countdownElements.forEach(el => {
        el.innerHTML = '<span style="color: #dc2626; font-weight: bold;">Promoção Encerrada</span>';
      });
      return;
    }

    // Calcular dias, horas, minutos, segundos
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Atualizar todos os contadores
    const countdownElements = document.querySelectorAll('.countdown-timer');
    countdownElements.forEach(el => {
      el.innerHTML = `
        <span style="display: inline-flex; gap: 1rem; font-weight: bold; color: #dc2626;">
          <span>${days}d</span>
          <span>${hours}h</span>
          <span>${minutes}m</span>
          <span>${seconds}s</span>
        </span>
      `;
    });
  }

  // Atualizar a cada segundo
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();